export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1040;
export const BASE_PATH = '/event-auto-create-preview';
export const APP_NAME = 'logged-out-auto-create-event';
export const SIGN_IN_PATH =
    '/signin/?referrer=/event-auto-create-preview/preview';

interface numOfAttendeesType {
    [key: number]: number;
}

export const NUMBER_OF_ATENDEES: numOfAttendeesType = {
    83: 20,
    84: 100,
    85: 500,
    87: 1000,
};

// TODO: These colors should be come from Marmalade
export const UI_COLORS = {
    background: '#FFFFFF',
    'background-rgb': '255,255,255',
    'neutral-100': '#f8f7fa',
    'neutral-700': '#585163',
    'ui-100': '#F8F7FA',
    'ui-200': '#EEEDF2',
    'ui-300': '#DBDAE3',
    'ui-500': '#A9A8B3',
    'ui-600': '#6F7287',
    'ui-700': '#4B4D63',
    'ui-800': '#39364F',
    'ui-800-rgb': '57,54,79',
    'ui-900': '#1E0A3C',
    'ui-1000': '#13002D',
    control: '#3659E3',
    'control--hover': '#3D64FF',
    'control--focus': '#3D64FF',
    'control--active': '#304FC9',
    'primary-brand': '#D1410C',
    'primary-brand--hover': '#F05537',
    'primary-brand--focus': '#F05537',
    'primary-brand--active': '#C23C0C',
    'inverse-primary-brand': '#FFFFFF',
    'secondary-brand': '#1E0A3C',
    'inverse-secondary-brand': '#FFFFFF',
    success: '#0D8547',
    'success--hover': '#179C55',
    'success--focus': '#179C55',
    'success--active': '#1A7545',
    'inverse-success': '#FFFFFF',
    warning: '#FFF58C',
    'inverse-warning': '#1E0A3C',
    error: '#C5162E',
    'error--hover': '#E02E46',
    'error--focus': '#E02E46',
    'error--active': '#B01A2E',
    'inverse-error': '#FFFFFF',
    progress: '#4BE1A0',
    'error-text': '#C5162E',
    'error-text--hover': '#E02E46',
    'error-text--focus': '#E02E46',
    'error-text--active': '#B01A2E',
};

export const BREAKPOINTS = {
    SMALL_NARROW: 360,
    SMALL: 480,
    SMALL_WIDE: 660,
    MEDIUM_NARROW: 792,
    MEDIUM: 960,
    MEDIUM_WIDE: 1080,
    LARGE_NARROW: 1152,
    LARGE: 1272,
    LARGE_WIDE: 1608,
};
